import React, { memo } from "react";
// import Moment from "moment/moment";
import dayjs from "dayjs";
import TransactionLink from "../../../../TransactionLink";
import { RowType } from "../../../../../containers/AppPage/Reports/AgedDetail/utils/RowType";
import { useLingui } from "@lingui/react";

function Date({ record }) {
    useLingui();
    if (record.rowType === RowType.spacer)
        return null;
    if (record.rowType === RowType.heading)
        return record.contactName;
    if (record.rowType === RowType.type_total || record.rowType === RowType.category_total)
        return record.date;
    return (
        <TransactionLink
            transaction={record}
            label={dayjs(record.date).format('DD/MM/YYYY')}
        />
    );
}

export default memo(Date);
